// Client-side geocoding (Nominatim / OpenStreetMap) with in-memory cache.
// Fallback only, used when a trip lacks coordinates from the backend.
const cache = new Map();

export async function geocodePlace(query) {
  const key = (query || "").trim().toLowerCase();
  if (!key) return null;
  if (cache.has(key)) return cache.get(key);
  try {
    const resp = await fetch(
      `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=it&q=${encodeURIComponent(query)}`,
      { headers: { Accept: "application/json" } }
    );
    if (!resp.ok) throw new Error(`geocode ${resp.status}`);
    const results = await resp.json();
    const first = results[0];
    const value = first ? [Number(first.lat), Number(first.lon)] : null;
    cache.set(key, value);
    return value;
  } catch {
    cache.set(key, null);
    return null;
  }
}
